import { registerLocaleData } from '@angular/common';
// LANGUAGE RELATED
import localeEn from '@angular/common/locales/en-GB';
import localeEt from '@angular/common/locales/et';
import localeFi from '@angular/common/locales/fi';
import localeLt from '@angular/common/locales/lt';
import localeLv from '@angular/common/locales/lv';
import localeSv from '@angular/common/locales/sv';


import { DEFAULT_CURRENCY_CODE, LOCALE_ID } from '@angular/core';

// LANGUAGE RELATED
registerLocaleData(localeEn);
registerLocaleData(localeEt);
registerLocaleData(localeFi);
registerLocaleData(localeLt);
registerLocaleData(localeLv);
registerLocaleData(localeSv);

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';

import { AuthInterceptor } from './shared/authconfig.interceptor';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule, NgbNavModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

// Login and logout
import { LoginComponent } from 'src/app/components/login/login.component';
import { LogoutComponent } from 'src/app/components/logout/logout.component';

import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';

import { TranslateFieldPipe } from './pipes/translate-field.pipe';
import { LocaleSortPipe } from './pipes/locale-sort.pipe';

import { HomeComponent } from './components/home/home.component';
import { environment } from 'src/environments/environment';
import { NgChartsModule } from 'ng2-charts';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { LeafletDrawModule } from '@asymmetrik/ngx-leaflet-draw';
import { MainComponent } from './components/main/main.component';

import { CategoriesComponent } from './components/categories/categories.component';
import { CampaignsComponent } from './components/campaigns/campaigns.component';
import { EditComponent as CampaignEditComponent } from './components/campaigns/edit/edit.component';
import { RecentComponent as CampaignRecentComponent } from './components/campaigns/recent/recent.component';
import { SearchComponent as CampaignSearchComponent } from './components/campaigns/search/search.component';
import { AssetComponent } from './components/campaigns/edit/asset/asset.component';
import { AreaComponent } from './components/campaigns/edit/area/area.component';
import { PlacementsComponent } from './components/placements/placements.component';
import { RecentComponent as PlacementRecentComponent } from './components/placements/recent/recent.component';
import { SearchComponent as PlacementSearchComponent } from './components/placements/search/search.component';
import { EditComponent as PlacementEditComponent } from './components/placements/edit/edit.component';
import { PictureComponent } from './components/placements/edit/picture/picture.component';
import { SettingsComponent } from './components/settings/settings.component';
import { SignupComponent } from './components/signup/signup.component';
import { BillingComponent } from './components/settings/billing/billing.component';
import { UsersComponent } from './components/settings/users/users.component';
import { EditComponent as UsersEditComponent } from './components/settings/users/edit/edit.component';
import { PasswordComponent as UsersPasswordComponent } from './components/settings/users/edit/password/password.component';
import { OrganizationComponent } from './components/settings/organization/organization.component';

const config: SocketIoConfig = { url: environment.ws_url, options: {
  auth: (cb) => {
    cb({ token: localStorage.getItem('media_access_token') }) 
  }
}}

@NgModule({
  declarations: [
    AppComponent,
    TranslateFieldPipe,
    LocaleSortPipe,
    LoginComponent,
    LogoutComponent,
    SignupComponent,
    HomeComponent,
    MainComponent,
    CategoriesComponent,
    CampaignsComponent,
    CampaignEditComponent,
    CampaignRecentComponent,
    CampaignSearchComponent,
    AssetComponent,
    AreaComponent,
    PlacementsComponent,
    PlacementRecentComponent,
    PlacementSearchComponent,
    PlacementEditComponent,
    PictureComponent,
    SettingsComponent,
    BillingComponent,
    UsersComponent,
    UsersEditComponent,
    UsersPasswordComponent,
    OrganizationComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    NgbModule,
    NgbNavModule,
    NgbDropdownModule,
    RouterModule,
    DataTablesModule,
    SocketIoModule.forRoot(config),
    NgChartsModule,
    LeafletModule,
    LeafletDrawModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: DEFAULT_CURRENCY_CODE, useValue: environment.currency },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
